(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("newsEntry", [], factory);
	else if(typeof exports === 'object')
		exports["newsEntry"] = factory();
	else
		root["newsEntry"] = factory();
})(window, function() {
return 